export default {
  contestList: state => state.contestList,
  contestDetails: state => state.contestDetails
}
